export interface CtaContentInputApiModel {
    question_text: string
}

export interface SubmitCtaInputApiModel {
    content: CtaContentInputApiModel,
    full_name: string,
    email: string,
    template_id: number,
    cta_button: string
}